import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent } from 'vue';
import ConfirmDialog from '@/components/common/confirm-dialog.vue';
import { useRepositories } from '@/plugins/repositories';
import { useStore } from '@/store/useStore';
import { useTelemetry } from '@/plugins/telemetry';
export default defineComponent({
  components: {
    ConfirmDialog: ConfirmDialog
  },
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();
    var repositories = useRepositories();
    var telemetry = useTelemetry();
    var store = useStore();
    var cancelHandler = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return repositories.users.skipInputUserProfile();
            case 3:
              _context.next = 8;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              // スキップに失敗した場合、翌日に再度表示されてしまうはずだが、当日の利用は問題ないためエラーをレポートするだけにする
              telemetry.sendErrorTelemetry(_context.t0, route);
            case 8:
              store.commit('setFirstAccessOfTheDay', false);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5]]);
      }));
      return function cancelHandler() {
        return _ref.apply(this, arguments);
      };
    }();
    var confirmHandler = function confirmHandler() {
      router.push("/profile/wizard?redirect_url=".concat(encodeURIComponent(route.fullPath)));
    };
    return {
      confirmHandler: confirmHandler,
      cancelHandler: cancelHandler
    };
  }
});